import {
	IGetSubCategoryInfo,
	IGetSubcategoryInfoV2,
	IGetSubCategoriesShort,
	IGetSubCategoriesArguments,
	ICreateSubCategory,
	ICreateSubcategoryV2,
	IUpdateSubCategory,
	IUpdateSubcategoryV2,
	IGetPaginatedSubCategories,
	ISubCategory,
	IGetPaginatedSubcategoriesByCustomerV2,
	ISubcategoryByCustomerV2,
	IGetPaginatedSubcategoriesByRestaurantV2,
	ISubcategoryByRestaurantV2,
	IGetSubCategoryPositionListArguments,
	IGetSubCategoryPositionList,
	IGetSubCategoryPositionListV2,
	IGetSubCategoryPositionChainsArguments,
	IGetSubCategoryPositionChains,
	IUpdateSubCategoryPositions,
	IGetSubcategoryRestaurantPropertiesArguments,
	IGetSubcategoryRestaurantProperties,
	IUpdateSubcategoryRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForSubcategory,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

// Menu v1
const serviceGetSubCategoryInfo = (subCategoryID: string): Promise<IGetSubCategoryInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/SubCategories/${subCategoryID}` });
};
// Menu v1
// Menu v2
const serviceGetSubcategoryInfoV2 = (subcategoryID: string): Promise<IGetSubcategoryInfoV2> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/subcategories/${subcategoryID}` });
};
// Menu v2

// Menu v1
const serviceGetSubCategoriesShort = (categoryIds: string[]): Promise<IGetSubCategoriesShort> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/SubCategories/short`, data: { categoryIds } });
};
// Menu v1
// Menu v2
const serviceGetSubCategoriesShortV2 = (args: IGetSubCategoriesArguments): Promise<IGetSubCategoriesShort> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/categories/${args.categoryId}/subcategories${
			args.restaurantId ? `?restaurantId=${args.restaurantId}` : ''
		}`,
	});
};
// Menu v2

// Menu v1
const serviceCreateSubCategory = (data: ICreateSubCategory): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/SubCategories`, data });
};
// Menu v1
// Menu v2
const serviceCreateSubcategoryV2 = (data: ICreateSubcategoryV2): Promise<AxiosResponse<{ id: string }>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/subcategories`, data });
};
// Menu v2

// Menu v1
const serviceUpdateSubCategory = (data: IUpdateSubCategory): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/SubCategories/${data.id}`, data });
};
// Menu v1
// Menu v2
const serviceUpdateSubCategoryV2 = (data: IUpdateSubcategoryV2): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/subcategories/${data.id}`, data });
};
// Menu v2

// Menu v1
const serviceGetPaginatedSubCategories = (args: IGetPaginatedSubCategories): Promise<AxiosResponse<ISubCategory>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/SubCategories/filtered`, data: args });
};
// Menu v1
// Menu v2
const serviceGetPaginatedSubcategoriesByCustomerV2 = (
	args: IGetPaginatedSubcategoriesByCustomerV2,
): Promise<AxiosResponse<ISubcategoryByCustomerV2>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/subcategories:search`, data: args });
};

const serviceGetPaginatedSubcategoriesByRestaurantV2 = (
	args: IGetPaginatedSubcategoriesByRestaurantV2,
): Promise<AxiosResponse<ISubcategoryByRestaurantV2>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/restaurant-subcategories:search`, data: args });
};
// Menu v2

// Menu v1
const serviceDeleteSubCategory = (subCategoryID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/SubCategories/${subCategoryID}`,
	});
};
// Menu v1
// Menu v2
const serviceDeleteSubcategoryV2 = (subcategoryID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/v2/subcategories/${subcategoryID}`,
	});
};
// Menu v2

// Menu v1
const serviceGetSubCategoryPositionList = (
	args: IGetSubCategoryPositionListArguments,
): Promise<IGetSubCategoryPositionList> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/SubCategories/positionList`, data: args });
};
// Menu v1
// Menu v2
const serviceGetSubcategoryPositionListV2 = (
	args: IGetSubCategoryPositionListArguments,
): Promise<IGetSubCategoryPositionListV2> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/subcategories?categoryId=${args.categoryId}`,
	});
};
// Menu v2

// Menu v1
const serviceGetSubCategoryPositionChains = (
	args: IGetSubCategoryPositionChainsArguments,
): Promise<IGetSubCategoryPositionChains> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/SubCategories/positions`, data: args });
};
// Menu v1
// Menu v2
const serviceGetSubCategoryPositionChainsV2 = (
	args: IGetSubCategoryPositionChainsArguments,
): Promise<IGetSubCategoryPositionChains> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/same-subcategory-set/${args.categoryId}`,
	});
};
// Menu v2

// Menu v1
const serviceUpdateSubCategoryPositions = (data: IUpdateSubCategoryPositions): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/SubCategories/changePositions`, data });
};
// Menu v1
// Menu v2
const serviceUpdateSubCategoryPositionsV2 = (data: IUpdateSubCategoryPositions): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/subcategories:change-positions`, data });
};
// Menu v2

const serviceGetSubcategoryRestaurantProperties = (
	args: IGetSubcategoryRestaurantPropertiesArguments,
): Promise<IGetSubcategoryRestaurantProperties> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/restaurant-subcategories/${args.subcategoryId}`,
	});
};

const serviceUpdateSubcategoryRestaurantProperties = (
	data: IUpdateSubcategoryRestaurantProperties,
): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/restaurants/${data.restaurantId}/restaurant-subcategories/${data.subcategoryId}`,
		data,
	});
};

const serviceUpdateSubcategoryRestaurantPropertiesAsPatch = (
	data: IUpdateRestaurantPropertiesAsPatchForSubcategory,
): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/restaurant-subcategories/${data.subCategoryId}`,
		data,
	});
};

const serviceUpdateRestaurantsInSubcategory = (data: {
	subcategoryId: string;
	restaurantIds: string[];
}): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/subcategories:update-restaurants`, data });
};

const serviceUpdateDishesInSubcategory = (data: {
	subCategoryId: string;
	restaurantId: string;
	dishIds: string[];
}): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/subcategories:update-dishes`, data });
};

const serviceGetSubcategoryPhotos = (args: {
	subCategoryIds: string[];
	size: 1 | 2 | 3;
}): Promise<
	AxiosResponse<{
		files: {
			id: string;
			preSignedUrl: Nullable<string>;
		}[];
	}>
> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/subcategory-photos:search`, data: args });
};

export {
	serviceGetSubCategoryInfo,
	serviceGetSubcategoryInfoV2,
	serviceGetSubCategoriesShort,
	serviceGetSubCategoriesShortV2,
	serviceCreateSubCategory,
	serviceCreateSubcategoryV2,
	serviceUpdateSubCategory,
	serviceUpdateSubCategoryV2,
	serviceGetPaginatedSubCategories,
	serviceGetPaginatedSubcategoriesByCustomerV2,
	serviceGetPaginatedSubcategoriesByRestaurantV2,
	serviceDeleteSubCategory,
	serviceDeleteSubcategoryV2,
	serviceGetSubCategoryPositionList,
	serviceGetSubcategoryPositionListV2,
	serviceGetSubCategoryPositionChains,
	serviceGetSubCategoryPositionChainsV2,
	serviceUpdateSubCategoryPositions,
	serviceUpdateSubCategoryPositionsV2,
	serviceGetSubcategoryRestaurantProperties,
	serviceUpdateSubcategoryRestaurantProperties,
	serviceUpdateSubcategoryRestaurantPropertiesAsPatch,
	serviceUpdateRestaurantsInSubcategory,
	serviceUpdateDishesInSubcategory,
	serviceGetSubcategoryPhotos,
};
